import useDefinedContext from "hooks/useDefinedContext";
import LeaderboardsContext from "../contexts/LeaderboardsContext";

function useLeaderboardsContext() {
  return useDefinedContext(LeaderboardsContext);
}
export default useLeaderboardsContext;
